var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as _ from 'lodash';
import { childrenExist, AutoControlledComponent, doesNodeContainClick, EventStack, commonPropTypes, } from '../../lib';
import Ref from '../Ref/Ref';
import PortalInner from './PortalInner';
import { FocusTrapZone } from '../../lib/accessibility/FocusZone';
/**
 * A component that allows you to render children outside their parent.
 */
var Portal = /** @class */ (function (_super) {
    __extends(Portal, _super);
    function Portal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.clickSubscription = EventStack.noSubscription;
        _this.handleMount = function () {
            _this.clickSubscription = EventStack.subscribe('click', _this.handleDocumentClick);
            _.invoke(_this.props, 'onMount', _this.props);
        };
        _this.handleUnmount = function () {
            _this.clickSubscription.unsubscribe();
            _.invoke(_this.props, 'onUnmount', _this.props);
        };
        _this.handlePortalRef = function (portalNode) {
            _this.portalNode = portalNode;
        };
        _this.handleTriggerRef = function (triggerNode) {
            _this.triggerNode = triggerNode;
            _.invoke(_this.props, 'triggerRef', triggerNode);
        };
        _this.handleTriggerClick = function (e) {
            var rest = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                rest[_i - 1] = arguments[_i];
            }
            var trigger = _this.props.trigger;
            _.invoke(_this.props, 'onTriggerClick', e); // Call handler from parent component
            _.invoke.apply(// Call handler from parent component
            _, [trigger, 'props.onClick', e].concat(rest)); // Call original event handler
            _this.trySetState({ open: !_this.state.open });
        };
        _this.handleDocumentClick = function (e) {
            if (!_this.portalNode || // no portal
                doesNodeContainClick(_this.triggerNode, e) || // event happened in trigger (delegate to trigger handlers)
                doesNodeContainClick(_this.portalNode, e) // event happened in the portal
            ) {
                return; // ignore the click
            }
            _.invoke(_this.props, 'onOutsideClick', e);
            _this.trySetState({ open: false });
        };
        return _this;
    }
    Portal.prototype.renderComponent = function () {
        return (React.createElement(React.Fragment, null,
            this.renderPortal(),
            this.renderTrigger()));
    };
    Portal.prototype.renderPortal = function () {
        var _a = this.props, children = _a.children, content = _a.content, trapFocus = _a.trapFocus;
        var open = this.state.open;
        var contentToRender = childrenExist(children) ? children : content;
        var focusTrapZoneProps = (_.keys(trapFocus).length && trapFocus) || {};
        return (open && (React.createElement(Ref, { innerRef: this.handlePortalRef },
            React.createElement(PortalInner, { onMount: this.handleMount, onUnmount: this.handleUnmount }, trapFocus ? (React.createElement(FocusTrapZone, __assign({}, focusTrapZoneProps), contentToRender)) : (contentToRender)))));
    };
    Portal.prototype.renderTrigger = function () {
        var _a = this.props, trigger = _a.trigger, triggerAccessibility = _a.triggerAccessibility;
        return (trigger && (React.createElement(Ref, { innerRef: this.handleTriggerRef }, React.cloneElement(trigger, __assign({ onClick: this.handleTriggerClick }, triggerAccessibility.attributes, triggerAccessibility.keyHandlers)))));
    };
    Portal.autoControlledProps = ['open'];
    Portal.propTypes = __assign({}, commonPropTypes.createCommon({
        animated: false,
        as: false,
        className: false,
        styled: false,
    }), { defaultOpen: PropTypes.bool, onMount: PropTypes.func, onUnmount: PropTypes.func, open: PropTypes.bool, trigger: PropTypes.node, triggerRef: PropTypes.func, triggerAccessibility: PropTypes.object, onTriggerClick: PropTypes.func, onOutsideClick: PropTypes.func, trapFocus: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]) });
    Portal.defaultProps = {
        triggerAccessibility: {},
    };
    return Portal;
}(AutoControlledComponent));
export default Portal;
